export default {
  pushEvent(event, eventCategory, eventAction, eventLabel) {
      if (window['dataLayer'] && (typeof window['dataLayer'] != 'undefined') && (window['dataLayer'] != null)) {
          const data = {
              event: event,
              eventLabel: eventLabel,
              eventAction: eventAction,
              eventCategory: eventCategory
          };

          window['dataLayer'].push(data);
        console.log('GTM pushEvent', data);
      }
  },

  initAddthis() {
      if (window['addthis'] && (typeof window['addthis'] != 'undefined') && (window['addthis'] != null)) {
        addthis.addEventListener('addthis.menu.share', (event) => {
          this.pushEvent('clic-partage', 'partage', 'clic', event.data.title);
        });
      }
  }
}


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/js/utils/tagManager.js